module.exports = __webpack_public_path__ + "img/flat collar edges length.62e18f7f.png";